// Component to show a confirmation dialog. Has an embedded StatusMessage that the
// caller can show UI when the user confirms. I use this UI to show status of
// async calls to server before dismissing the confirm UI.
//
// Pass in props:
//      show - Show/hide dialog
//      title - Title for dialog
//      body - body for dialog
//      confirmText - Text for footer button to confirm.
//      onConfirm - function to call when confirm button tapped. Passed StatusMessage UI functions...
//      onHide - function to call when cancel button is hit

import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useStatusMessage } from './StatusMessage';


function Confirm({
    show,
    title,
    body,
    onConfirm,
    onHide,
    cancelText = 'Cancel',
    confirmText = 'Confirm',
    showCancelButton = true,
}) {
    const [StatusMessage, {showText, showError, showLoading, hideStatus}] = useStatusMessage();
    // A confirmed action can be slow (cascade deletes walk one row at a time).
    // Lock both buttons while it runs so an impatient second click can't start a
    // second copy of the same work.
    const [busy, setBusy] = useState(false);

    var cancelButton = showCancelButton ? (
            <Button className='btn btn-primary' onClick={onHide} disabled={busy}>
                {cancelText}
            </Button>
        ) : null;

    // User confirmed, call the callback with UI elements.
    async function handleConfirm() {
      if (busy) {
        return;
      }
      setBusy(true);
      try {
        await onConfirm({
          showText: showText,
          showError: showError,
          hideStatus: hideStatus,
          showLoading: showLoading
        });
      } finally {
        setBusy(false);
      }
    }

    return (
        <Modal show={show}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                {cancelButton}
                <Button className='btn btn-danger' onClick={handleConfirm} disabled={busy}>
                    {confirmText}
                </Button>
                <StatusMessage/>
            </Modal.Footer>
        </Modal>
    )
}

export default Confirm;